var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BackendHttpService } from '../../core/backend-http.service';
import { apiEndpoints } from '../../app.constants';
import { StringUtils } from '../../utils/string.utils';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var ProjectService = /** @class */ (function (_super) {
    __extends(ProjectService, _super);
    function ProjectService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createOrUpdateProjectSubject = new BehaviorSubject(null);
        return _this;
    }
    /**
     * create a new project or update existing project
     * @param {Project} project
     * @returns {Observable<any>}
     */
    ProjectService.prototype.createOrEditProject = function (project) {
        var data = {
            advertiserID: project.advertiserId,
            keywords: project.keywords.map(function (keyword) { return ({
                id: keyword.id,
                keywordType: keyword.keywordType ? keyword.keywordType.id : 0,
                keyword: keyword.keyword
            }); }),
            name: project.name,
            countries: project.countries
        };
        if (project.id > 0) {
            data = Object.assign({}, data, { id: project.id });
            return this.post(apiEndpoints.updateProject, data);
        }
        else {
            return this.post(apiEndpoints.newproject, data);
        }
    };
    ProjectService.prototype.deleteProject = function (projectId) {
        return this.delete(apiEndpoints.deleteProject.replace(':project_id', projectId));
    };
    ProjectService.prototype.validateProject = function (project) {
        var errors = [];
        if (!project.name || StringUtils.trim(project.name) === '') {
            errors.push({ name: 'project_name',
                message: this.translate.instant('project.name_mandatory') });
        }
        if (project.keywords.length === 0) {
            errors.push({ name: 'project_keywords',
                message: this.translate.instant('project.keyword_mandatory') });
        }
        return errors;
    };
    ProjectService.prototype.triggerCreateOrUpdateProject = function (project) {
        this.createOrUpdateProjectSubject.next(project);
    };
    Object.defineProperty(ProjectService.prototype, "createOrUpdateProjectObserver", {
        get: function () {
            return this.createOrUpdateProjectSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    return ProjectService;
}(BackendHttpService));
export { ProjectService };



// WEBPACK FOOTER //
// ./src/app/services/project/project.service.ts.pre-build-optimizer.js